<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShowData">新增渠道</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button type="primary" size="small" style="margin-right: 5px" @click="coypeData(row)">复制渠道数据</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
			<Form ref="addForm" :model="addForm" :label-width="120">

				<FormItem label="主渠道名称" prop="mainChannelName">
					<Input v-model="addForm.mainChannelName" maxlength="100" placeholder="请输入主渠道名称"></Input>
				</FormItem>
				<FormItem label="主渠道编码" prop="mainChannelCode">
					<Input v-model="addForm.mainChannelCode" maxlength="100" placeholder="请输入主渠道编码"></Input>
				</FormItem>
				<FormItem label="子渠道名称" prop="childChannelName">
					<Input v-model="addForm.childChannelName" maxlength="100" placeholder="请输入子渠道名称"></Input>
				</FormItem>
				<FormItem label="子渠道编码" prop="childChannelCode">
					<Input v-model="addForm.childChannelCode" maxlength="100" placeholder="请输入子渠道编码"></Input>
				</FormItem>

				<FormItem label="渠道推广链接" prop="qrCodeImg">
					<Input v-model="addForm.qrCodeImg" maxlength="500" placeholder="请输入渠道推广链接"></Input>
				</FormItem>
				<FormItem label="统计数据链接" prop="countUrl">
					<Input v-model="addForm.countUrl" maxlength="500" placeholder="请输入统计数据链接"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateLight">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition10'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {

				},
				codeImgs: [],
				addJobShow: false,
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addForm: {
					id: undefined,
					mainChannelName: undefined,
					childChannelName: undefined,
					mainChannelCode: undefined,
					childChannelCode: undefined,
					qrCodeImg: undefined,
					countUrl: undefined,
				},
				addRule: {

				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '数据ID',
						width: 200,
						key: 'id',
						align: 'center'
					},
					{
						title: '主渠道名称',
						width: 200,
						key: 'mainChannelName',
						align: 'center'
					},
					{
						title: '主渠道编码',
						width: 150,
						key: 'mainChannelCode',
						align: 'center'
					},
					{
						title: '子渠道名称',
						key: 'childChannelName',
						align: 'center',
						width: 200,
					},{
						title: '子渠道编码',
						key: 'childChannelCode',
						align: 'center',
						width: 150,
					},{
						title: '渠道推广链接',
						key: 'qrCodeImg',
						align: 'center',
						width: 300,
					},{
						title: '渠道统计链接',
						key: 'countUrl',
						align: 'center',
						width: 300,
					}, {
						title: '创建日期',
						key: 'createTime',
						align: 'center',
						width: 200,
					}, {
						title: '操作',
						slot: 'action',
						width: 350,
						align: 'center'
					}

				]
			},
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.channelPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateLight() {
				const that = this
				api.statistics
					.addOrEditCountChannel(this.addForm)
					.then(res => {
						that.initAdd()
						that.addJobShow = false
						that.refreshData()
					})
					.then(() => {
						that.loading = false
					})
			},
			editData(row) {
				this.addForm=row;
				this.addJobShow=true
			},

			initAdd() {
				this.addForm = {
					id: undefined,
					mainChannelName: undefined,
					childChannelName: undefined,
					mainChannelCode: undefined,
					childChannelCode: undefined,
					qrCodeImg: undefined,
					countUrl: undefined,
				}
			},
			addShowData(){
				this.initAdd()
				this.addJobShow=true
			},
			coypeData(data){
				const textarea = document.createElement('textarea');
				textarea.value = "https://www.mgadmob.com/dxjz/index.html#/pages/index/channeldataPageNew?channelCode="+data.childChannelCode+"&channelId="+data.id+"&channelType=2";
				textarea.style.position = 'fixed';
				textarea.style.opacity = '0';
				document.body.appendChild(textarea);
				textarea.select();
				try {
					// 尝试执行复制操作
					const successful = document.execCommand('copy');
					if (successful) {
						this.$Message.success("复制成功");
					} else {
						this.$Message.success("复制失败");
					}
				} catch (err) {
					("复制时出错");
				}
				// 移除临时的 textarea 元素
				document.body.removeChild(textarea);
			}
		}

	}
</script>